import { render, staticRenderFns } from "./AddCardCollectionBtn.vue?vue&type=template&id=5c9df4de&"
import script from "./AddCardCollectionBtn.vue?vue&type=script&lang=js&"
export * from "./AddCardCollectionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports